import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { success as setPost } from '../post'
import { Post } from '../post/types'
import { Slice, PostByTagSlice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  tag: string
  postSlugs?: string[]
}

const getSlice = (slice: PostByTagSlice): PostByTagSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false,
    payload: undefined
  })
}

const slice = createSlice({
  name: 'blog/postsByTag',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { tag } = action.payload
      const slice = getSlice(state[tag])
      slice.isFetching = true
      state[tag] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { tag, postSlugs } = action.payload
      const slice = getSlice(state[tag])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
      slice.payload = postSlugs
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { tag } = action.payload
      const slice = getSlice(state[tag])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchPostsByTag (tag: string, currentPage: number = 1): PWAThunk {
  const postSlugs: string[] = []
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ tag }))
    try {
      const response = await magentoClient.getClient().blog.fetchPostList({
        filters: {
          tag_url_key: tag
        },
        currentPage
      })
      response.data?.posts?.items?.forEach((post: Post) => {
        postSlugs.push(post.url_key)
        dispatch(setPost({ post, slug: post.url_key }))
      })
      dispatch(success({
        tag,
        postSlugs
      }))
    } catch (e) {
      dispatch(failure({ tag }))
    }
  }
}
